import React from "react";

export default class GetStartedForm extends React.Component {
  constructor(props) {
    // Init props and state
    super(props);
    this.state = {
      fields: {
        email: "",
      },
      error: null,
    };
  }

  handleValidation() {
    let fields = this.state.fields;
    let errors = null;
    let formIsValid = true;

    //Name
    if (!fields["email"]) {
      formIsValid = false;
      errors = "Enter your email to get started.";
    } else if (typeof fields["email"] !== "undefined") {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!fields["email"].match(emailRegex)) {
        formIsValid = false;
        errors = "Please enter valid email address.";
      }
    }

    this.setState({ error: errors });
    return formIsValid;
  }

  contactSubmit(e) {
    e.preventDefault();

    if (this.handleValidation()) {
      try {
        window.Growlytics.user.identify(this.state.fields.email, {
          email: this.state.fields.email,
        });
        window.Growlytics.events.track("Business Site - Get Started", {
          Page: window.location.pathname,
          email: this.state.fields.email,
        });

        // // Update on intercom as well.
        // window.Intercom("update", {
        //   email: this.state.fields.email,
        // });
        // window.Intercom("trackEvent", "Business Site - Get Started", {
        //   Page: window.location.pathname,
        //   email: this.state.fields.email,
        // });
      } catch (err) {
        console.error("Failed to track", err);
      }

      setTimeout(() => {
        window.location.href = "https://app.growlytics.in/register?email=" + this.state.fields.email;
      }, 750);
    }
  }

  handleChange(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({ fields });
  }

  render() {
    return (
      <div className="mt-8 sm:max-w-lg sm:mx-auto sm:text-center lg:text-left lg:mx-0">
        <form name="contactform" action="#" method="POST" className="mt-3 sm:flex" onSubmit={this.contactSubmit.bind(this)}>
          <label htmlFor="email" className="sr-only">
            Email
          </label>
          <input type="text" name="email" id="email" onChange={this.handleChange.bind(this, "email")} value={this.state.fields["email"]} className="block w-full py-3 text-base rounded-md pl-4 placeholder-gray-500 shadow-sm focus:ring-primary focus:border-primary-400 sm:flex-1 border-2 border-primary-200" placeholder="Enter your email" />
          <button
            type="submit"
            className="mt-3 w-full px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary shadow-sm hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 
            focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:flex-shrink-0 sm:inline-flex sm:items-center sm:w-auto"
          >
            Get Started{" "}
          </button>
        </form>

        {!this.state.error && (
          // <p className="mt-2 text-sm text-gray-500">
          //   Take one month free trial. No credit card required.
          // </p>
          <p>&nbsp;</p>
        )}

        {this.state.error && <p className="mt-2 text-sm text-red-600">{this.state.error}</p>}
      </div>
    );
  }
}
